// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2u6Lq","textarea":"styles_textarea__1rdSy"};